import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import toNumber from 'lodash/toNumber';
import values from 'lodash/values';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

// VARIABLES
import { CHART_COLORS } from 'globals.js';

// LOCAL COMPONENTS
import TooltipContent from './tools/Tooltip';

// STYLES
import styles from './chart.module.scss';

// FUNCTIONS

// MAIN COMPONENT
export default function PieChartComponent({
  className, //
  data = [],
  dataKey = 'data',
  dataFormat,
  height = 320
}) {
  const scaledData = useMemo(() => {
    return data.filter(d => d[dataKey] > 0);
  }, [dataKey, data]);

  const totalData = useMemo(() => {
    return scaledData.reduce((total, { data }) => total + data, 0);
  }, [scaledData]);

  const renderLabel = ({ name, value = toNumber(value), percent }) => `${name}: ${parseFloat(percent * 100).toFixed(1)}% (${dataFormat(value)})`;

  return (
    <ResponsiveContainer width="100%" height={height} debounce={100} className={clsx(styles.chart, className)}>
      <PieChart margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
        <Pie data={scaledData} dataKey={dataKey} nameKey="name" label={renderLabel} innerRadius="53%">
          {scaledData.map(({ color, onClick }, i) => (
            <Cell
              key={i}
              fill={CHART_COLORS[color] || color || values(CHART_COLORS)[i]}
              onClick={onClick}
              style={{ cursor: onClick ? 'pointer' : 'default' }}
            />
          ))}
        </Pie>
        <Tooltip content={<TooltipContent totalData={totalData} dataFormat={dataFormat} showPercentage />} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
